var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Blog"}},[_c('Navbar',{attrs:{"setorders":_vm.orders,"booking":_vm.setbooking}}),_vm._m(0),_c('div',{staticClass:"space"}),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_vm._v("col-sm-8")]),_c('div',{staticClass:"col-sm-8"},[_vm._v("col-sm-4")])])])
}]

export { render, staticRenderFns }